import { ArrowRight } from "lucide-react";

export default function MidCTABanner() {
  return (
    <section
      data-testid="mid-cta-banner"
      className="py-12 md:py-16 bg-primary text-primary-foreground"
    >
      <div className="container-wide flex flex-col md:flex-row items-start md:items-center justify-between gap-8 reveal">
        <div className="max-w-2xl">
          <p className="text-[11px] uppercase tracking-[0.22em] text-[hsl(var(--brand-terra))] font-semibold">
            Prêt à avancer ?
          </p>
          <h3 className="mt-3 font-display text-3xl md:text-4xl leading-tight">
            Obtenez votre devis personnalisé,{" "}
            <span className="italic font-light text-white/85">gratuit et sans engagement</span>.
          </h3>
        </div>
        <a
          href="#contact"
          data-testid="mid-cta-button"
          className="group inline-flex items-center gap-2 bg-[hsl(var(--brand-terra))] text-white px-8 py-5 text-sm font-medium tracking-wide rounded-full transition-all duration-300 hover:-translate-y-0.5 hover:bg-[hsl(var(--brand-terra)/0.9)] shrink-0"
        >
          Demander mon devis gratuit
          <ArrowRight
            size={18}
            className="transition-transform duration-300 group-hover:translate-x-1"
          />
        </a>
      </div>
    </section>
  );
}
